import { Command } from '@ckeditor/ckeditor5-core';
import SalariesModal from './salaries-modal';
export default class InsertSalariesCommand extends Command {
    execute() {
        try {
            const salariesModal = new SalariesModal();
            salariesModal
                .show()
                .then((salaries) => {
                this.editor.model.change((writer) => {
                    this.editor.model.insertContent(createSalaries(writer, salaries));
                });
            })
                .catch(() => { });
        }
        catch (error) {
            console.error(error);
        }
    }
    refresh() {
        const model = this.editor.model;
        this.isEnabled = true;
    }
}
function formatSalary(num) {
    return Math.abs(num) > 999
        ? Math.sign(num) * parseFloat((Math.abs(num) / 1000).toFixed(1)) + 'k'
        : Math.sign(num) * Math.abs(num);
}
function createSalaries(writer, salaries) {
    const salariesEl = writer.createElement('salaries');
    const headingEl = writer.createElement('heading');
    writer.appendText('title', headingEl);
    writer.append(headingEl, salariesEl);
    let total = 0;
    salaries.forEach((s) => {
        total += s['salary'];
    });
    salaries = salaries.map((s) => {
        const value = s['salary'];
        return {
            ...s,
            width: Math.round((value / total) * 100) + salaries.length * 15,
        };
    });
    // writer.append('heading3', salariesEl)
    salaries.forEach((i) => {
        const salaryItemEl = writer.createElement('salaryItem');
        const salaryTitleEl = writer.createElement('salaryTitle');
        const salaryAmntEl = writer.createElement('salaryAmnt');
        const salaryBarEmptyEl = writer.createElement('salaryBarEmpty');
        const salaryBarEl = writer.createElement('salaryBar');
        writer.setAttribute('width', i.width.toString() + '%', salaryBarEl);
        writer.append(salaryBarEl, salaryBarEmptyEl);
        writer.append(salaryTitleEl, salaryItemEl);
        writer.append(salaryAmntEl, salaryItemEl);
        writer.append(salaryBarEmptyEl, salaryItemEl);
        writer.appendText(i['title'], salaryTitleEl);
        writer.appendText('$' + formatSalary(i['salary']).toString() + ' / yr', salaryAmntEl);
        writer.append(salaryItemEl, salariesEl);
    });
    // const salariesHeading = writer.createElement('salariesHeading')
    // writer.appendElement(salariesHeading, salariesEl)
    // writer.appendElement(items, salariesEl)
    const salaryFooter = writer.createElement('salaryFooter');
    writer.appendText('The information is for US and Canada', salaryFooter);
    writer.append(salaryFooter, salariesEl);
    return salariesEl;
}
